import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
    fastFoodProducts,
    riceMenuProducts,
    pizzaProducts,
    dessertProducts,
    coffeeProducts,
} from '../../assets/fake-data/products';

const Recipe = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <section className="page-section">
            <Container>
                <div className="bg-img">
                    <h2 className="pageTitle">Recipe</h2>
                </div>
                <p>
                    Find the perfect food and drink ideas for every ocassion, from weeknight dinners
                    to holiday feasts.
                </p>
                <h2>Top 100 easy dinner recipes</h2>

                <Row>
                    <Col lg="3" md="4" sm="6">
                        <div className="recipe__item">
                           
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Recipe;
